function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { AdornedInput, Adornment, Anchor, Checkbox, FormField, FormHelp, IconMail, IconPhone, IconUser, Input, Label, LabeledControl, LoadingButton, Paragraph, Text, Tooltip, TooltipPopper, TriggerText } from '@zillow/constellation';
import { RX_EMAIL, RX_PHONE } from '@zillow/validation-regexes';
import { track } from '@zillow/universal-analytics';
import { formatCity } from '../utils/addressUtils';
import { getCopy } from '../utils/copyUtils';
var StyledParagraph = styled(Paragraph).withConfig({
  displayName: "ContactAgentFormContent__StyledParagraph",
  componentId: "sc-18ck317-0"
})(["text-align:", ";"], function (props) {
  return props.centerAlignedNote ? 'center' : 'left';
});
var legalTooltip = /*#__PURE__*/React.createElement(Tooltip, {
  body: /*#__PURE__*/React.createElement(Paragraph, {
    "data-testid": "real-estate-professionals-tooltip"
  }, "\u201CReal estate professionals\u201D includes the real estate agents and brokers, mortgage lenders and loan officers, property managers and other professionals you interact with through Zillow. Zillow Premier Agent is an advertising program that helps connect customers to local real estate professionals. Zillow Premier Agent partners are paid advertisers and are not affiliated with Zillow, Inc. brokerage or any of its affiliates.")
});

var ContactAgentFormContent = function ContactAgentFormContent(_ref) {
  var _errors$name, _errors$phone, _errors$email;

  var property = _ref.property,
      viewer = _ref.viewer,
      _ref$showCheckBox = _ref.showCheckBox,
      showCheckBox = _ref$showCheckBox === void 0 ? true : _ref$showCheckBox,
      _ref$centerAlignedNot = _ref.centerAlignedNote,
      centerAlignedNote = _ref$centerAlignedNot === void 0 ? true : _ref$centerAlignedNot,
      page = _ref.page,
      location = _ref.location,
      treatment = _ref.treatment,
      onSubmit = _ref.onSubmit,
      onSubmitSuccess = _ref.onSubmitSuccess,
      zatlasEndpoint = _ref.zatlasEndpoint,
      contactFormVersion = _ref.contactFormVersion,
      trackingParam = _ref.trackingParam;
  var submitButtonText = 'Submit';

  var _useState = useState(showCheckBox),
      _useState2 = _slicedToArray(_useState, 2),
      disableSubmit = _useState2[0],
      setDisableSubmit = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      submitErrMsg = _useState4[0],
      setSubmitErrMsg = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showLoadingButton = _useState6[0],
      setShowLoadingButton = _useState6[1];

  var checkboxText = contactFormVersion === 'sebastian-360' || !property.city ? "I'm the owner of this home" : "I\u2019m a homeowner in the " + formatCity(property.city) + " area"; // Known issue in v6: https://github.com/react-hook-form/react-hook-form/issues/2887
  // eslint-disable-next-line zillow/@typescript-eslint/unbound-method

  var _useForm = useForm({
    mode: 'onBlur',
    defaultValues: {
      name: viewer === null || viewer === void 0 ? void 0 : viewer.name,
      email: viewer === null || viewer === void 0 ? void 0 : viewer.email,
      phone: ''
    }
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var handleSubmitInner = function handleSubmitInner(formData) {
    return new Promise(function ($return, $error) {
      var _response$errors, response;

      setShowLoadingButton(true);
      setSubmitErrMsg('');
      return Promise.resolve(onSubmit({
        property: property,
        zatlasEndpoint: zatlasEndpoint,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        source: trackingParam
      })).then(function ($await_3) {
        try {
          response = $await_3;
          track({
            category: 'Homes',
            label: "Submit|" + page + "|" + location + "|" + treatment,
            action: 'Seb 360 Upsell'
          });

          if ((_response$errors = response.errors) !== null && _response$errors !== void 0 && _response$errors.submit) {
            setShowLoadingButton(false);
            setSubmitErrMsg(response.errors.submit);
          } else {
            onSubmitSuccess();
          }

          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledParagraph, {
    marginBottom: "sm",
    centerAlignedNote: centerAlignedNote
  }, getCopy(contactFormVersion, 'formBody')), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(handleSubmitInner)
  }, /*#__PURE__*/React.createElement(FormField, {
    marginBottom: errors.name ? 'xs' : 'sm'
  }, /*#__PURE__*/React.createElement(AdornedInput, {
    inputId: "name",
    leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(IconUser, {
      fontColor: "textDark"
    })),
    input: /*#__PURE__*/React.createElement(Input, _extends({
      placeholder: "Name",
      fluid: true
    }, register('name', {
      required: 'Please enter your name.'
    })))
  }), ((_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message) && /*#__PURE__*/React.createElement(FormHelp, {
    error: true
  }, errors.name.message)), /*#__PURE__*/React.createElement(FormField, {
    marginBottom: errors.phone ? 'xs' : 'sm'
  }, /*#__PURE__*/React.createElement(AdornedInput, {
    inputId: "phone",
    leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(IconPhone, {
      fontColor: "textDark"
    })),
    input: /*#__PURE__*/React.createElement(Input, _extends({
      "data-testid": "om-contact-agent-phone-input",
      placeholder: "Phone",
      fluid: true
    }, register('phone', {
      required: 'Please enter a valid US phone number.',
      pattern: {
        value: RX_PHONE,
        message: 'Please enter a valid US phone number.'
      }
    })))
  }), ((_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.message) && /*#__PURE__*/React.createElement(FormHelp, {
    error: true
  }, errors.phone.message)), /*#__PURE__*/React.createElement(FormField, {
    marginBottom: errors.email ? 'xs' : 'sm'
  }, /*#__PURE__*/React.createElement(AdornedInput, {
    inputId: "email",
    leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(IconMail, {
      fontColor: "textDark"
    })),
    input: /*#__PURE__*/React.createElement(Input, _extends({
      placeholder: "Email",
      type: "text",
      fluid: true
    }, register('email', {
      required: 'Please enter a valid email address.',
      pattern: {
        value: RX_EMAIL,
        message: 'Please enter a valid email address.'
      }
    })))
  }), ((_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message) && /*#__PURE__*/React.createElement(FormHelp, {
    error: true
  }, errors.email.message)), /*#__PURE__*/React.createElement(FormField, null, showCheckBox && /*#__PURE__*/React.createElement(LabeledControl, {
    marginBottom: "xs",
    controlId: "homeowner",
    label: /*#__PURE__*/React.createElement(Label, null, checkboxText),
    onChange: function onChange() {
      setDisableSubmit(!disableSubmit);
    },
    control: /*#__PURE__*/React.createElement(Checkbox, {
      "data-testid": "homeowner-checkbox",
      name: "homeowner"
    })
  })), /*#__PURE__*/React.createElement(FormField, {
    marginBottom: submitErrMsg ? 'xs' : 'sm'
  }, /*#__PURE__*/React.createElement(LoadingButton, {
    type: "submit",
    buttonType: "primary",
    fluid: true,
    disabled: disableSubmit || showLoadingButton,
    loading: showLoadingButton
  }, submitButtonText), submitErrMsg && /*#__PURE__*/React.createElement(FormHelp, {
    error: true
  }, submitErrMsg))), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "form-legal-terms",
    fontType: "legal",
    as: "p"
  }, "By pressing ", submitButtonText, ", you agree that Zillow Group and its affiliates, and", ' ', /*#__PURE__*/React.createElement(TooltipPopper, {
    triggered: legalTooltip
  }, /*#__PURE__*/React.createElement(TriggerText, null, "real estate professionals")), ' ', "may call/text you about your inquiry, which may involve use of automated means and prerecorded/artificial voices. You don't need to consent as a condition of buying any property, goods or services. Message/data rates may apply. You also agree to our ", /*#__PURE__*/React.createElement(Anchor, {
    href: "/z/corp/terms"
  }, "Terms of Use"), ". Zillow does not endorse any real estate professionals. We may share information about your recent and future site activity with your agent to help them understand what you're looking for in a home."));
};

export default ContactAgentFormContent;
//# sourceMappingURL=ContactAgentFormContent.js.map